import {Box, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

import {AppButton, ButtonContainer} from '@/app/shared-components';
import InputTextField from '@/app/shared-components/InputTextField/InputTextField';
import SecureEncryptFooter from '@/app/shared-components/SecureEncryptFooter/SecureEncryptFooter';
import {IMAGES} from '@/constants/images';
import {validateNameInput} from '@/utils/validateNames';

import PrivacyPolicy from '../../components/PrivacyPolicy/PrivacyPolicy';

import {useViewModelProvider, ViewModelProvider} from './ViewModelContext';

import './styles';

const TeenPreloadCardDataContent = () => {
  const {t} = useTranslation();
  const {
    firstName,
    lastName,
    selectedTheme,
    isDisabled,
    setFirstName,
    setLastName,
    handleContinue,
    handleOnClickChangeDesign,
  } = useViewModelProvider();

  return (
    <Box className="teen-preload-card-data-container">
      <img
        src={IMAGES.LOGO_TEXT_BLACK.src}
        height="auto"
        className="teen-preload-modak-logo"
      />
      <Box className="header">
        <Typography
          className="title"
          variant="h2">
          What's <span className="your-kid">your kid's</span> name?
        </Typography>
      </Box>
      <Box className="fixed-box">
        <Box sx={{flex: 1}}>
          <InputTextField
            id="teen-preload-first-name-input"
            label={t('teen_preload_card_data.first_name')}
            maxLength={20}
            value={firstName}
            setValue={(value: string) => setFirstName(validateNameInput(value))}
            onBlur={() => setFirstName(firstName.trim())}
          />
        </Box>
        <Box sx={{flex: 1}}>
          <InputTextField
            id="teen-preload-last-name-input"
            label={t('teen_preload_card_data.last_name')}
            maxLength={20}
            value={lastName}
            setValue={(value: string) => setLastName(validateNameInput(value))}
            onBlur={() => setLastName(lastName.trim())}
          />
        </Box>
      </Box>
      <Box className="card-theme-container">
        <Box className="card-theme-title-container">
          <Typography className="card-theme-title">
            {t('teen_preload_card_data.card_theme_title')}
          </Typography>
        </Box>
        <Box className="card-theme-image-container">
          <Box className="card-theme-image">
            <Box
              component="img"
              src={`/assets/images/cards/MoCardFront-${selectedTheme}.webp`}
              alt={'Mo Card'}
              className="card-image"
            />
            <Typography className="kid-card-name">
              {firstName.split(' ')[0]} {lastName.split(' ')[0]}
            </Typography>
          </Box>
        </Box>
        <Box className="card-theme-action-container">
          <Typography
            className="card-theme-action-title"
            onClick={handleOnClickChangeDesign}>
            {t('teen_preload_card_data.change_design')}
          </Typography>
        </Box>
      </Box>
      <SecureEncryptFooter />
      <Box style={{marginLeft: '4px'}}>
        <PrivacyPolicy />
      </Box>
      <ButtonContainer sticky>
        <AppButton
          id="teen-preload-card-data-continue-button"
          label={t('teen_preload_card_data.button')}
          onClick={handleContinue}
          disabled={isDisabled}
        />
      </ButtonContainer>
    </Box>
  );
};

const TeenPreloadCardDataPage = () => (
  <ViewModelProvider>
    <TeenPreloadCardDataContent />
  </ViewModelProvider>
);

export default TeenPreloadCardDataPage;
